<div class="input-group input-group-sm">
    <spv2-legal-entity-dropdown [companyId]="companyId" [(value)]="value" (valueChange)="valueChange.emit($event)" (userChangedValue)="startDebounce();" ></spv2-legal-entity-dropdown>
</div>  